import React from "react";
import Card from "../../components/generics/Card";

const TailoredOverview = props => (
  <Card message="Search using the top bar" style={{height:"100%",borderRadius: "12px 12px 0 0"}} messageIcon="search"/>
);

export default TailoredOverview;
